import { ChangeEvent, DragEvent, useEffect, useState } from "react";
import placeholderImage from '../../../../../assets/images/placeholder-image.svg';
import styles from "./index.module.scss";

interface EventImageProps {
    fileSelected?: string | File;
    acceptedFileTypes?: string[];
    handleChange: (file: any) => void;
}

const EventImage = ({
    acceptedFileTypes = ['image/jpeg', 'image/png', 'image/webp'],
    fileSelected,
    handleChange
}: EventImageProps) => {
    const [imagePreview, setImagePreview] = useState<string | null>(null);

    useEffect(() => {
        if (fileSelected instanceof File) {
            readFileAsDataUrl(fileSelected)
                .then((setImagePreview))
                .catch(() => setImagePreview(null));
        } else {
            setImagePreview(fileSelected || null);
        }
    }, [fileSelected]);

    const readFileAsDataUrl = (file: File): Promise<string> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    };

    const handleImageUpload = (e: ChangeEvent<HTMLInputElement>) => {
        const selectedFile = e.target.files?.[0];
        if (selectedFile) {
            readFileAsDataUrl(selectedFile).then((dataUrl) => {
                setImagePreview(dataUrl);
                handleChange(selectedFile);
            }
            ).catch(() => setImagePreview(null));
        }
    };

    const handleDragOver = (e: DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDrop = (e: DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();

        const selectedFile = e.dataTransfer.files?.[0];
        if (selectedFile && acceptedFileTypes.includes(selectedFile.type)) {
            readFileAsDataUrl(selectedFile)
                .then((dataUrl) => {
                    setImagePreview(dataUrl);
                    handleChange(selectedFile);
                })
                .catch(() => setImagePreview(null));
        }
    };

    const handleCancel = () => {
        setImagePreview(null);
        handleChange(null);
    };

    const renderUploadButton = () => {
        return (
            <label htmlFor="upload-file" className={styles.customFileInput}>
                <span>{fileSelected ? "Change Cover Image" : "Upload Cover Image"}</span>
            </label>
        );
    }

    return (
        <div>
            <div className={`col-12 col-md-10 ${styles.container}`}
                onDragOver={handleDragOver}
                onDrop={handleDrop}>
                {!imagePreview ? (<div className={styles.imageWrapper}>
                    <img src={placeholderImage} className={styles.imagePlaceholder} alt="Placeholder" />
                    {renderUploadButton()}
                </div>
                ) : (
                    <div className={styles.previewWrapper}>
                        <img src={imagePreview} alt="Preview" className={styles.previewImage} />
                    </div>
                )}
                <input
                    type="file"
                    accept={acceptedFileTypes.join(',')}
                    onChange={handleImageUpload}
                    className={styles.fileInput}
                    aria-label="Upload cover image"
                    id="upload-file"
                    name="thumbnail"
                />
            </div>
            {fileSelected && (
                <div className={styles.buttonContainer}>
                    <button className={styles.cancelButton} onClick={handleCancel}>
                        Remove Image
                    </button>
                    {renderUploadButton()}
                </div>

            )}
        </div>
    )
}

export default EventImage;